import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CustomDropdownButtonWithCheckboxComponent } from './custom-dropdown-button-with-checkbox.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, FormsModule],
  exports: [CustomDropdownButtonWithCheckboxComponent],
  declarations: [CustomDropdownButtonWithCheckboxComponent],
  providers: []
})
export class CustomDropdownButtonWithCheckboxModule {}
